import TrackingRepository from "../repository/tracking-repository";

export const tracking = new TrackingRepository();